import React from "react";

type InputFieldProps = {
  label: string;
  value: string | null | undefined;
};

export const InputField = ({ label, value }: InputFieldProps) => {
  return (
    <div className="PreviewBookingModalBeta__inputGroup flex justify-between items-center pb-3 border-b border-[var(--borderColor)]">
      <span className="label text-[0.95rem] font-normal text-[var(--primaryColor)] min-w-[120px]">
        {label}
      </span>
      <span className="input-value text-[0.95rem] text-[var(--primaryColor)] font-normal text-right flex-1">
        {value ?? "-"}
      </span>
    </div>
  );
};
